import React from "react";
import PropTypes from "prop-types";
import { useStoreHook } from "../../store"; // Import Zustand state
import Modal from "./Modal";

const ModalLayout = () => {
  const { isOpen } = useStoreHook((state) => state.modal);

  if (!isOpen) return null;

  return (
    <div className="modals-parent">
      <div className="bg-overlay" />
      <div className="modal-box">
        <div className="modal-content">
          <Modal />
        </div>
      </div>
    </div>
  );
};

ModalLayout.propTypes = {
  isHidden: PropTypes.bool,
};

export default ModalLayout;
